import { resourceText } from 'src/app/shared/services/localization';
import { TenantService } from 'src/app/tenant/tenant.service';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { ProfileService } from 'src/app/shared/profile/profile/profile.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { AuthService } from '../account/auth.service';
import { Location } from '@angular/common';
import { User } from '../account/user.model';

@Component({
    selector: 'app-my-profile',
    templateUrl: './my-profile.component.html',
    styleUrls: ['./my-profile.component.scss'],
    standalone: false
})
export class MyProfileComponent implements OnInit, AfterViewInit, OnDestroy {
  householdSetup = false;
  confirmDeletion = false;
  deletingAccount = false;
  accountDeleted = false;
  deletionError = '';
  deletionTakingLonger = false;
  private deletionNoticeTimer: ReturnType<typeof setTimeout> | null = null;
  async deleteAccount() {
    if (this.deletingAccount || this.accountDeleted) return;
    this.deletingAccount = true; this.deletionError = '';
    this.clearDeletionNotice();
    this.deletionNoticeTimer = setTimeout(() => {
      this.deletionTakingLonger = true;
      this.deletionNoticeTimer = null;
    }, 15000);
    try {
      await this.profileService.unsubscribe(this.userId);
    } catch {
      // A lost response cannot tell us whether the server completed deletion.
      this.deletionError = resourceText('WE_COULD_NOT_CONFIRM_THE_CHANGE_PLEASE_TRY_AGAIN');
      this.deletingAccount = false;
      return;
    } finally {
      this.clearDeletionNotice();
    }
    // A browser storage/navigation failure must not turn confirmed deletion into
    // an apparent server failure or offer to delete the same account again.
    this.confirmDeletion = false;
    this.accountDeleted = true;
    try { localStorage.removeItem('CSBarcodeID'); } catch { /* Storage may be blocked. */ }
    try { this.authService.logout(0); } catch { /* Logout clears in-memory identity before storage. */ }
    this.globalService.currentUserId = null;
    this.globalService.fromRegistration = false;
    this.deletingAccount = false;
    try {
      await this._router.navigate(['/' + this.tenantService.getTenant() + '/home'], {
        replaceUrl: true, state: { accountDeleted: true }
      });
    } catch { /* Keep the confirmed-deletion screen and Continue as guest action. */ }
  }
  private clearDeletionNotice() {
    if (this.deletionNoticeTimer !== null) clearTimeout(this.deletionNoticeTimer);
    this.deletionNoticeTimer = null;
    this.deletionTakingLonger = false;
  }

  ngOnDestroy() {
    this.clearDeletionNotice();
  }
  User: User = null;
  userId: string = null;
  constructor(
    public profileService: ProfileService,
    private authService: AuthService,
    private _router: Router,
    private route: ActivatedRoute,
    private globalService: GlobalService,
    private tenantService: TenantService,
    private _location: Location
  ) {}

  goHome() {
    if (this.deletingAccount) return;
    this.globalService.fromRegistration = false;
    this._router.navigate(['/' + this.tenantService.getTenant() + '/home']);
  }

  async ngOnInit() {

    this.householdSetup = this.route.snapshot.queryParamMap.get('setup') === 'household';
    this.globalService.isBack = false;
    this.userId = this.globalService.currentUserId;
  }

  ngAfterViewInit() {
    setTimeout(() => {
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.selectedOption = "MYPROFILE";    
    this.globalService.screenHeader = resourceText('MY_PROFILE_HOUSEHOLD');
    });
  }         
}
